import { EMPTY_CELL } from '@/shared/constants'

import { hasFigure, upTo } from './numberFormat'

/**
 * A backend `…Percent` field drawn as it arrives: `12.5` → `12.5%`, `-5` → `-5%`, `12` → `12%`.
 * `null`, `undefined` and `NaN` are `—`: a period the backend had no base to compare against
 * is not `0%`.
 *
 * A share (`0.125` for 12.5%) is a `…Ratio` field and is not this call.
 */
export function formatPercent(value: number | null | undefined): string {
  if (!hasFigure(value)) return EMPTY_CELL

  return `${upTo(1).format(value)}%`
}
